import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import ButtonSecondary from '../../button/button-secondary';
import ButtonPseudo from '../../button/button-pseudo';
import { ButtonSize } from '../../button/types';
import IconUp from '../../icons/up';
import IconDown from '../../icons/down';
import Textarea from '../../textarea/textarea';
import formatDate from '../../../helpers/format-date';
import IconChat from '../../icons/chat';
import ClickOutsideDetector from '../../autocomplete/click-outside-detector';
import { RequestBlockTypes } from './types';

import styles from '../transaction.module.css';

export default function RequestBlock({
  selectedRequest,
  setSelectedRequest,
  requestText,
  setRequestText,
  action,
  internal,
  companyOfficials,
  recipients,
  senders,
  individualCustomer,
  recipientAccount,
  senderAccount,
  chats,
  createChatWithMessage,
  chatCreateInProgress,
  withoutBorder,
}: RequestBlockTypes) {
  const [menuVisible, setMenuVisible] = useState(false);
  const [selectedCustomer, setSelecteCustomer] = useState<{
    name: string;
    id?: string;
    type?: 'sender' | 'recipient';
  }>({ name: '', id: '' });

  const lastChat = chats && chats[chats.length - 1];

  return (
    <>
      {!selectedRequest && !lastChat && (
        <div
          className={`${styles.blacklistRequirements} ${
            withoutBorder ? styles.withoutBorder : ''
          }`}
        >
          <ButtonSecondary
            text="Request documents or clarification via chat"
            className={`${styles.blacklistRequirementItem} button-white`}
            onClick={() =>
              setSelectedRequest('Request documents or clarification via chat')
            }
            size={ButtonSize.SMALL}
            disabled={Boolean(action)}
          />
        </div>
      )}
      {(selectedRequest || lastChat) && (
        <div className={styles.seletedRequestWrapper}>
          <div className={styles.selectedRequestTitle}>
            Request documents or clarification via chat
          </div>
          {lastChat && (
            <>
              <div className={styles.selectedRequestEmployee}>
                <div>{`Created by ${lastChat?.employee?.profile?.firstName} ${lastChat?.employee?.profile?.lastName}`}</div>
                <div>{formatDate(lastChat?.createdAt, true)}</div>
              </div>
              <NavLink
                to={`/messages/requests/in-progress/${lastChat.id}`}
                className={styles.chatLink}
                target="_blank"
              >
                <IconChat width={16} height={16} />
                Go to chat
              </NavLink>
            </>
          )}
          {!lastChat && (
            <>
              <ClickOutsideDetector setOptionsListVisible={setMenuVisible}>
                <div className={styles.documentRequestCustomerWrapper}>
                  <button
                    type="button"
                    className={`${styles.documentRequestCustomerButton} ${
                      selectedCustomer.name ? styles.filled : ''
                    }`}
                    onClick={() => setMenuVisible(!menuVisible)}
                  >
                    {selectedCustomer.name ||
                      'Select a customer to start the chat'}
                    {menuVisible ? <IconUp /> : <IconDown />}
                  </button>
                  {menuVisible && (
                    <ul className={styles.documentRequestList}>
                      {internal && (
                        <>
                          <li className={styles.documentRequestListTitle}>
                            Senders
                          </li>
                          {senders && senders.length > 0 && (
                            <>
                              {senders.map((item) => (
                                <li key={item.id}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setMenuVisible(false);

                                      setSelecteCustomer({
                                        name: `${item.user?.profile?.firstName} ${item.user?.profile?.lastName}`,
                                        id: item.id,
                                        type: 'sender',
                                      });
                                    }}
                                  >{`${item.user?.profile?.firstName} ${item.user?.profile?.lastName}`}</button>
                                </li>
                              ))}
                            </>
                          )}
                          {!senders?.length &&
                            senderAccount?.organization?.type ===
                              'INDIVIDUAL' && (
                              <li>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setMenuVisible(false);

                                    setSelecteCustomer({
                                      name: `${senderAccount?.organization?.firstName} ${senderAccount?.organization?.lastName}`,
                                      type: 'sender',
                                    });
                                  }}
                                >
                                  {`${senderAccount?.organization?.firstName} ${senderAccount?.organization?.lastName}`}
                                </button>
                              </li>
                            )}
                          {!senders?.length &&
                            senderAccount?.organization?.type ===
                              'CORPORATE' && (
                              <li>There are no company officials</li>
                            )}
                          <li className={styles.documentRequestListTitle}>
                            Recipients
                          </li>
                          {recipients && recipients.length > 0 && (
                            <>
                              {recipients.map((item) => (
                                <li key={item.id}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setMenuVisible(false);

                                      setSelecteCustomer({
                                        name: `${item.user?.profile?.firstName} ${item.user?.profile?.lastName}`,
                                        id: item.id,
                                        type: 'recipient',
                                      });
                                    }}
                                  >{`${item.user?.profile?.firstName} ${item.user?.profile?.lastName}`}</button>
                                </li>
                              ))}
                            </>
                          )}
                          {!recipients?.length &&
                            recipientAccount?.organization?.type ===
                              'INDIVIDUAL' && (
                              <li>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setMenuVisible(false);
                                    setSelecteCustomer({
                                      name: `${recipientAccount?.organization?.firstName} ${recipientAccount?.organization?.lastName}`,
                                      type: 'recipient',
                                    });
                                  }}
                                >
                                  {`${recipientAccount?.organization?.firstName} ${recipientAccount?.organization?.lastName}`}
                                </button>
                              </li>
                            )}
                          {!recipients?.length &&
                            recipientAccount?.organization?.type ===
                              'CORPORATE' && (
                              <li>There are no company officials</li>
                            )}
                        </>
                      )}
                      {!internal && (
                        <>
                          {companyOfficials &&
                            companyOfficials.length > 0 &&
                            companyOfficials?.map((item) => (
                              <li key={item.id}>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setMenuVisible(false);
                                    setSelecteCustomer({
                                      name: `${item.user?.profile?.firstName} ${item.user?.profile?.lastName}`,
                                      id: item.userId,
                                    });
                                  }}
                                >{`${item.user?.profile?.firstName} ${item.user?.profile?.lastName}`}</button>
                              </li>
                            ))}
                          {!companyOfficials?.length &&
                            individualCustomer?.organization?.type ===
                              'INDIVIDUAL' && (
                              <li>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelecteCustomer({
                                      name: `${individualCustomer?.organization?.firstName} ${individualCustomer?.organization?.lastName}`,
                                    });
                                    setMenuVisible(false);
                                  }}
                                >
                                  {`${individualCustomer?.organization?.firstName} ${individualCustomer?.organization?.lastName}`}
                                </button>
                              </li>
                            )}
                          {!companyOfficials?.length &&
                            individualCustomer?.organization?.type ===
                              'CORPORATE' && (
                              <li>There are no company officials</li>
                            )}
                        </>
                      )}
                    </ul>
                  )}
                </div>
              </ClickOutsideDetector>

              <Textarea
                name="requestText"
                value={requestText}
                onChange={(e) => setRequestText(e.target.value)}
                placeholder="Write to the client..."
                className={styles.documentRequestTextarea}
              />
              <div className={styles.selectedRequestControls}>
                <ButtonSecondary
                  text={chatCreateInProgress ? 'Loading...' : 'Send'}
                  className={`${styles.sendRequestButton} ${
                    !requestText || !selectedCustomer.name
                      ? styles.sendRequestButtonDisabled
                      : ''
                  }`}
                  size={ButtonSize.SMALL}
                  onClick={() =>
                    createChatWithMessage &&
                    createChatWithMessage({
                      message: requestText as string,
                      userId: selectedCustomer.id || '',
                      type: selectedCustomer.type || undefined,
                    })
                  }
                  disabled={
                    !requestText ||
                    !selectedCustomer.name ||
                    chatCreateInProgress
                  }
                />
                <ButtonPseudo
                  className={styles.cancelRequestButton}
                  text="Cancel"
                  onClick={() => setSelectedRequest('')}
                  size={ButtonSize.SMALL}
                />
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
